import Helpers from "./helpers";

declare var Splide: any;

export default class Usps {

	private sliderInstance: any;
	private previouslyDesktop: boolean;

	constructor() {

		this.setSliderState();
		window.addEventListener('resize', Helpers.debounce(this.setSliderState, 100).bind(this));

	}

	private sliderMaxWidth() {
		switch (Helpers.activeSite()) {
			case 'Tapwarehouse':
				return 979;
			case 'Drench':
				return 1249;
			case 'Toasty':
				return 1199;
			default:
				return 979;
		}
	}

	private setSliderState() {

		if (window.matchMedia('(max-width:' + this.sliderMaxWidth() + 'px)').matches) {
			if (!this.sliderInstance) {
				this.createSlider();
			}
			this.previouslyDesktop = false;
		} else {
			if (this.sliderInstance) {
				this.sliderInstance.destroy();
				this.sliderInstance = null;
				this.removeClassesForMobileCarousel();
			}
			this.previouslyDesktop = true;
		}

	}

	 private createSlider() {

		 const element = document.querySelector('.js-usp-slider') as HTMLElement;
		 if (!element || typeof Splide === "undefined") return;

		 this.setClassesForMobileCarousel();

		 this.sliderInstance = new Splide('.js-usp-slider', {
			 type: 'loop',
			 perPage: 1,
			 perMove: 1,
			 autoplay: true,
			 speed: 500,
			 interval: 5000,
			 pagination: false,
			 arrows: true,
			 keyboard: 'focused'
		 });

		 this.sliderInstance.on('mounted', () => {

			 this.setTabIndexOfLinks();
		 });

		 this.sliderInstance.on('moved', () => {
			 this.setTabIndexOfLinks();
			 
		 });

		 this.sliderInstance.mount();

		 if (this.previouslyDesktop) {
			 this.sliderInstance.go(0);
		 }

		 element.classList.add('c-usps--initialised');
	 }

	 /** Stop links from being focusable on slides out of view with aria-hidden */
	 private setTabIndexOfLinks() {
		 setTimeout(() => {
			 const slideItems = document.querySelectorAll('.js-usps .c-usps__list-item');
			 for (let i = 0; i < slideItems.length; i++) {
				 if (slideItems[i].getAttribute('aria-hidden') === "true") {
					 slideItems[i].querySelector('a').setAttribute('tabindex', '-1');
				 } else {
					 slideItems[i].querySelector('a').removeAttribute('tabindex');
				 }
				 slideItems[i].removeAttribute('role');
			 }
		 }, 1000);
	 }

	 private setClassesForMobileCarousel() {
		 document.querySelector('.js-usp-slider').classList.add('splide');
		 document.querySelector('.js-usp-slider-track').classList.add('splide__track');
		 document.querySelector('.js-usp-slider-list').classList.add('splide__list');
		 const slideItems = document.querySelectorAll('.js-slider-usp-item');
		 slideItems.forEach((item) => {
			 item.classList.add('splide__slide');
		 });
	 }

	 private removeClassesForMobileCarousel() {
		 document.querySelector('.js-usp-slider').classList.remove('splide');
		 document.querySelector('.js-usp-slider-track').classList.remove('splide__track');
		 document.querySelector('.js-usp-slider-list').classList.remove('splide__list');
		 const slideItems = document.querySelectorAll('.js-slider-usp-item');
		 slideItems.forEach((item) => {
			 item.classList.remove('splide__slide');
		 });
		 const element = document.querySelector('.js-usp-slider') as HTMLElement;
		 element.classList.remove('c-usps--initialised');
	 }

}
